let store = require("../store");
let actions = require("../actions");

let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;
let IconButton = mc.widgets.IconButton;

class UserFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: mc.utils.clone(this.props.user) || {
        firstName: "",
        lastName: "",
        email: "",
        emailCopy: "",
        locale: "en_US",
        timezone: "US/Eastern",
        accountId: store.getState().accountId
      },
      errors: [],
      submitting: false
    };
  }

  mutate(field, value) {
    this.setState({
      user: { ...this.state.user, [field]: value }
    });
  }

  setFirstName(evt) {
    this.mutate("firstName", evt.target.value);
  }

  setLastName(evt) {
    this.mutate("lastName", evt.target.value);
  }

  setEmail(evt) {
    this.mutate("email", evt.target.value.trim());
  }

  setEmailCopy(evt) {
    this.mutate("emailCopy", evt.target.value.trim());
  }

  setLocale(evt) {
    this.mutate("locale", evt.target.value);
  }

  cancel() {
    mc.ui.modal(null);
  }

  saveUser() {
    let user = this.state.user;
    let method = user.id ? "UPDATE" : "CREATE";

    let saveUser = () => {
      actions.saveUser(user, method).then((payload) => {
        if (payload.errors.length) {
          this.setState({
            errors: payload.errors,
            submitting: false
          });
        }
        else {
          this.props.onSave();

          mc.ui.modal(null);

          if (method === "CREATE") {
            mc.ui.alert(tx("user_saved", { email: user.email }));
          }
        }
      });

      this.setState({
        submitting: true
      });
    };

    if (method === "CREATE") {
      mc.ui.alert(tx("save_user_note"), {
        level: "warn",
        mode: "confirm",
        labels: {
          confirm: tx("confirm"),
          cancel: tx("cancel")
        },
        onHide: function (confirmed) {
          if (confirmed) {
            saveUser();
          }
        }
      });
    }
    else {
      saveUser();
    }
  }

  deleteUser() {
    let user = this.state.user;

    mc.ui.alert(tx("delete_user"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("confirm"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveUser(user, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              this.props.onSave();
              mc.ui.modal(null);
            }
          }).bind(this));

          this.setState({
            submitting: true
          });
        }
      }).bind(this)
    });
  }

  validate() {
    let user = this.state.user;

    let a = user.firstName.trim().length > 0 && user.lastName.trim().length > 0;
    let b = /.+@.+\..+/.test(user.email);
    let c = user.id !== undefined || user.email === user.emailCopy;

    return a && b && c;
  }

  static open(user, onSave) {
    mc.ui.modal(<UserFormView user={user} onSave={onSave}/>, { dismissable: false });
  }

  render() {
    let user = this.state.user;

    return (
      <div>
        <h1>{user.id ? mc.format.name(user) : tx("new_user")}</h1>
        <div className="rc-user-form-view">
          <table className="mc-form">
            <tbody>
              <tr>
                <th>{tx("first_name")}</th>
                <td>
                  <input
                    type="text"
                    maxLength="32"
                    value={user.firstName}
                    onChange={this.setFirstName.bind(this)}/>
                </td>
              </tr>
              <tr>
                <th>{tx("last_name")}</th>
                <td>
                  <input
                    type="text"
                    maxLength="32"
                    value={user.lastName}
                    onChange={this.setLastName.bind(this)}/>
                </td>
              </tr>
              <tr>
                <th>{tx("email_address")}</th>
                <td>
                  <input
                    type="text"
                    size="32"
                    maxLength="64"
                    value={user.email}
                    onChange={this.setEmail.bind(this)}
                    disabled={user.id !== undefined}/>
                </td>
              </tr>
              {user.id === undefined ? (
                <tr>
                  <th>{tx("retype_email_address")}</th>
                  <td>
                    <input
                      type="text"
                      size="32"
                      maxLength="64"
                      value={user.emailCopy}
                      onChange={this.setEmailCopy.bind(this)}/>
                  </td>
                </tr>
              ) : null}
              <tr>
                <th>{tx("email_language")}</th>
                <td>
                  <select value={user.locale} onChange={this.setLocale.bind(this)}>
                    <option value="en_US">{"English"}</option>
                    <option value="ja_JP">{"日本人"}</option>
                  </select>
                  <br/>
                  <small>{tx("language_note")}</small>
                </td>
              </tr>
            </tbody>
          </table>
          <FormFeedback errors={this.state.errors}/>
          <FormControls
            onSave={this.saveUser.bind(this)}
            onCancel={this.cancel.bind(this)}
            onDelete={user.id && user.id !== store.getState().user.user.id && this.deleteUser.bind(this)}
            enabled={!this.state.submitting && this.validate()}/>
        </div>
      </div>
    );
  }
}

module.exports = UserFormView;